angular.module('picmonicng').directive('learnAudioSeek', [
  'LearnService',
  function (LearnService) {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          scope.$apply(function () {
            if (LearnService.locked) return;
            
            var offset = element[0].getBoundingClientRect();
            LearnService.seek(((event.pageX - offset.left) / element.width()) * LearnService.audioElement.duration);
            LearnService.determineFact();
          });
        });
      },
    };
  },
]);
